/**
 * BudgetHistoryBridge — undo/redo façade over Budget Engine history.
 */

import type { BudgetCommandResult, BudgetEngine } from '@/engines/budget'

export class BudgetHistoryBridge {
  private readonly engine: BudgetEngine

  constructor(engine: BudgetEngine) {
    this.engine = engine
  }

  canUndo(): boolean {
    return this.engine.historySize().undo > 0
  }

  canRedo(): boolean {
    return this.engine.historySize().redo > 0
  }

  undo(): BudgetCommandResult {
    return this.engine.undo()
  }

  redo(): BudgetCommandResult {
    return this.engine.redo()
  }
}
